<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="sert"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><img alt="" height="100" src="images/logo-chicago-guides.jpg" width="147"/></p>
<p class="ser"><i>Digital Paper</i></p>
<p class="serau">Andrew Abbott</p>
<p class="ser"><i>Telling About Society</i></p>
<p class="serau">Howard S. Becker</p>
<p class="ser"><i>Tricks of the Trade</i></p>
<p class="serau">Howard S. Becker</p>
<p class="ser"><i>Writing Your Journal Article in Twelve Weeks</i></p>
<p class="serau">Wendy Laura Belcher</p>
<p class="ser"><i>The Craft of Research</i></p>
<p class="serau">Wayne C. Booth, Gregory G. Colomb, Joseph M. Williams, Joseph Bizup, and William T. FitzGerald</p>
<p class="ser"><i>From Dissertation to Book</i></p>
<p class="serau">William Germano</p>
<p class="ser"><i>Getting It Published</i></p>
<p class="serau">William Germano</p>
<p class="ser"><i>From Notes to Narrative</i></p>
<p class="serau">Kristen Ghodsee</p>
<p class="ser"><i>Thinking Like a Political Scientist</i></p>
<p class="serau">Christopher Howard</p>
<p class="ser"><i>Write No Matter What</i></p>
<p class="serau">Joli Jensen</p>
<p class="ser"><i>How to Write a BA Thesis</i></p>
<p class="serau">Charles Lipson</p>
<p class="ser"><i>Economical Writing</i></p>
<p class="serau">Deirdre Nansen McCloskey</p>
<p class="ser"><i>The Chicago Guide to Writing about Numbers</i></p>
<p class="serau">Jane E. Miller</p>
<p class="ser"><i>Going Public</i></p>
<p class="serau">Arlene Stein and Jessie Daniels</p>
<p class="ser"><i>The Writer’s Diet</i></p>
<p class="serau">Helen Sword</p>
<p class="ser"><i>A Manual for Writers of Research Papers, Theses, and Dissertations</i></p>
<p class="serau">Kate L. Turabian</p>
<p class="ser"><i>Student’s Guide to Writing College Papers</i></p>
<p class="serau">Kate L. Turabian</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-becker-0003.vue?0ac9da90